import { render } from "./CustomAvatar2.vue?vue&type=template&id=4ed88d1e"
import script from "./CustomAvatar2.vue?vue&type=script&lang=js"
export * from "./CustomAvatar2.vue?vue&type=script&lang=js"

import "./CustomAvatar2.vue?vue&type=style&index=0&id=4ed88d1e&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__